module.exports = __webpack_public_path__ + "img/family-mart.54d5310a.svg";